import React from 'react';

import IdeaMiniCard from '@buyside/components/presentation/IdeaMiniCard/ideaMiniCard';

import { ActivityFeedRankFragment } from '@interfaces/graphql-typings';

import styles from '../rankingStyles.scss';

const RankingMiniCardSection: React.FC<{
  user: ActivityFeedRankFragment['user'];
}> = ({ user }) => (
  <div data-testid="ranking-mini-card-section" className={styles.ideaRow}>
    <div className={styles.recentIdea}>
      <div className={styles.ideaHeading}>Most Recent:</div>
      <IdeaMiniCard idea={user?.recentIdea} />
    </div>
    <div className={styles.topIdeas}>
      <div className={styles.ideaHeading}>Top Ideas:</div>
      <div className={styles.ideaMiniCardList}>
        {user?.topIdeas?.edges?.map((edge, idx) => {
          return (
            <div key={idx} className={styles.ideaMiniCard}>
              <IdeaMiniCard idea={edge?.node} />
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

export default RankingMiniCardSection;
